export default class Service {
  constructor({ url, func, type }) {
    this.URL = url;
    this.treatment = func;
    this.type = type
  }

  async get() {
    const responce = fetch(this.URL);
    const result = responce.then((e) => this.treatment(e));
    return result;
  }
}
